document.addEventListener("DOMContentLoaded", function() {
  var myTabs = document.querySelectorAll(".tab-indicator .tab");

  function myTabClicks(tabClickEvent) {
    var clickedTab = tabClickEvent.currentTarget;

    // NEW: scope everything to this tab section only
    var indicator = clickedTab.closest('.tab-indicator');
    var container = indicator ? indicator.parentElement : document;

    // Deactivate tabs only in this section
    var sectionTabs = container.querySelectorAll(".tab-indicator .tab");
    for (var i = 0; i < sectionTabs.length; i++) {
      sectionTabs[i].classList.remove("active");
    }
    clickedTab.classList.add("active");

    tabClickEvent.preventDefault();

    // Deactivate panes only in this section
    var myContentPanes = container.querySelectorAll(".tab-pane");
    for (i = 0; i < myContentPanes.length; i++) {
      myContentPanes[i].classList.remove("active");
    }

    var anchorReference = clickedTab;
    console.log("Target:", tabClickEvent.target.nodeName);
    if (clickedTab.id !== "tab-1-link" && tabClickEvent.target.nodeName === 'IMG') {
      anchorReference = tabClickEvent.target.closest('a.tab');
    }

    var activePaneId = anchorReference.getAttribute("data-href");
    // Activate pane only within this section
    var activePane = container.querySelector(activePaneId);
    if (activePane) {
      activePane.classList.add("active");
    }
  }

  for (var i = 0; i < myTabs.length; i++) {
    myTabs[i].addEventListener("click", myTabClicks);
  }
});
